import React from 'react';
import { GlobeIcon, UsersIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Countdown } from '../Countdown';
const rows = [{
  label: 'Male Fertility Route — 6 Premium Volumes',
  value: 'USD 97'
}, {
  label: '5 Exclusive Clinical Bonuses',
  value: 'USD 140'
}];
const SPOTS_LEFT = 12;
const SPOTS_TOTAL = 150;
export function Offer() {
  const filled = Math.round((SPOTS_TOTAL - SPOTS_LEFT) / SPOTS_TOTAL * 100);
  return <section id="offer" className="w-full bg-ink-900 px-5 py-14 sm:py-20" data-id="element-155" data-mp="3a3cm8525dvot">
      <div className="mx-auto w-full max-w-xl lg:max-w-2xl" data-id="element-156" data-mp="3f2yyab68p5w1">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.24em] text-teal-400" data-id="element-157" data-mp="3juqfvw7f41a1">
          🏆 Special Launch Offer
        </p>
        <h2 className="mt-4 text-center font-display text-[26px] font-bold leading-tight text-white sm:text-[34px]" data-id="element-158" data-mp="3nw26o5212sjt">
          Everything you need to approach male infertility with a clear clinical path
        </h2>

        <div className="mt-9 overflow-hidden rounded-2xl border border-white/10 bg-ink-950" data-id="element-159" data-mp="1naq3qkb70sv">
          <div className="flex items-center justify-between border-b border-white/10 px-4 py-3 sm:px-6" data-id="element-160" data-mp="1kjdp1i35xn6p">
            <span className="text-[10px] font-extrabold uppercase tracking-[0.14em] text-white/40" data-id="element-161" data-mp="1foq57wj3tgyg">
              What you’ll receive
            </span>
            <span className="text-[10px] font-extrabold uppercase tracking-[0.14em] text-white/40" data-id="element-162" data-mp="16mqm8yoj42sv">
              Value
            </span>
          </div>
          {rows.map(row => <div key={row.label} className="flex items-start justify-between gap-4 border-b border-white/[0.06] px-4 py-4 sm:px-6" data-id="element-163" data-mp="1za4e4idde864">
              <span className="text-[14px] font-medium leading-snug text-white/80 sm:text-[15px]" data-id="element-164" data-mp="1pkt6z1a1ndkv">
                {row.label}
              </span>
              <span className="shrink-0 text-[14px] font-bold text-white/55 sm:text-[15px]" data-id="element-165" data-mp="2n1i62n7m01qk">
                {row.value}
              </span>
            </div>)}
          <div className="flex items-center justify-between px-4 py-4 sm:px-6" data-id="element-166" data-mp="3157cydoqv2m8">
            <span className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-167" data-mp="364ajk2kdhgwb">
              Total value
            </span>
            <span className="text-[15px] font-extrabold text-white/60 line-through" data-id="element-168" data-mp="2scdt02ycrf21">USD 237</span>
          </div>

          <div className="border-t border-teal-500/25 bg-teal-500/[0.07] px-5 py-7 text-center sm:px-8" data-id="element-169" data-mp="2wcxtngi4x0sx">
            <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-teal-300" data-id="element-170" data-mp="2ih2ftp2lefwe">
              Today you can get everything for just
            </p>
            <p className="mt-2 font-display text-[54px] font-bold leading-none text-white sm:text-6xl" data-id="element-171" data-mp="29fcoej8pngym">
              27 <span className="text-2xl align-top sm:text-3xl" data-id="element-172" data-mp="2dgo7s70zr5yd">USD</span>
            </p>
            <p className="mx-auto mt-3 max-w-sm text-[13px] leading-relaxed text-white/55" data-id="element-173" data-mp="7nzne59v5t7u">
              A one-time investment in a clinical resource you can continue using throughout your
              professional practice.
            </p>

            <div className="mt-6" data-id="element-174" data-mp="1w4hhud71zsdc">
              <CTAButton label="I want the Male Fertility Route" data-id="element-175" data-mp="1s5ihl5w9ojs8" />
              <p className="mt-3 text-[11px] font-medium text-white/50" data-id="element-176" data-mp="1s35tsc3tvf79">
                Immediate download · One-time payment · Lifetime access · 7-day guarantee
              </p>
            </div>

            <div className="mt-7 border-t border-white/10 pt-6" data-id="element-177" data-mp="213u5h05r13gz">
              <Countdown data-id="element-178" data-mp="2ft03iksuonna" />
            </div>

            <div className="mt-7 rounded-xl border border-amber-400/25 bg-amber-400/[0.08] px-4 py-4 text-left" data-id="element-179" data-mp="2avgqfo7w2gwx">
              <div className="flex items-center gap-2" data-id="element-180" data-mp="2ovrjmxwo87l9">
                <UsersIcon className="h-4 w-4 shrink-0 text-amber-300" aria-hidden="true" data-id="element-181" data-mp="2ot5c2y9s5s31" />
                <p className="text-[12px] font-extrabold uppercase tracking-[0.1em] text-amber-300" data-id="element-182" data-mp="2jwy2mvi6dygc">
                  Only {SPOTS_LEFT} spots left at the promotional price
                </p>
              </div>
              <div className="mt-3 h-2.5 w-full overflow-hidden rounded-full bg-white/10" role="progressbar" aria-valuemin={0} aria-valuemax={100} aria-valuenow={filled} aria-label="Promotional price spots already claimed" data-id="element-183" data-mp="pk8bumn3t5d6">
                <div className="h-full rounded-full bg-amber-400" style={{
                width: `${filled}%`
              }} data-id="element-184" data-mp="15x3do1zvbj1m" />
              </div>
              <p className="mt-2 text-[11px] font-medium text-white/55" data-id="element-185" data-mp="86yo00xfep2q">
                {filled}% of this launch’s spots are already claimed. After that, the price returns
                to USD 237.
              </p>
            </div>

            <p className="mt-6 flex items-start gap-2 text-left text-[12px] leading-relaxed text-white/50" data-id="element-186" data-mp="mxz5swk2bvbj">
              <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal-300" aria-hidden="true" data-id="element-187" data-mp="3lmo9oic6xy0x" />
              You can pay in your local currency. Currency conversion is handled automatically at
              checkout.
            </p>
          </div>
        </div>
      </div>
    </section>;
}